import React, { Component } from 'react';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const sliderSettings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 3000,
    arrows: false,
    cssEase: "ease",
};

class SubBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bannerlist: [],
        };
    }

    componentDidMount() {
        instance.post("/api/v1/getsubbanner", { System: Systems })
            .then((res) => {
                if (res.data.status === 200) {
                    this.setState({ bannerlist: res.data.message || [] });
                }
            })
            .catch(() => {});
    }

    render() {
        const { bannerlist } = this.state;
        if (!bannerlist || bannerlist.length === 0) return null;

        return (
            <div style={{ width: '100%', backgroundColor: '#000', padding: '8px 0' }}>
            <div style={{ maxWidth: 1040, margin: '0 auto' }}>
                <Slider {...sliderSettings}>
                    {bannerlist.map((item, index) => (
                        <div key={item.no || index}>
                            {item.type === 'video' && item.linkvideo ? (
                                <a href={item.linkurl || '#'} style={{ display: 'block' }}>
                                    <video
                                        src={item.linkvideo}
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        style={{ width: '100%', display: 'block', borderRadius: '0.5rem' }}
                                    />
                                </a>
                            ) : (
                                <a href={item.linkurl || '#'} style={{ display: 'block' }}>
                                    <img
                                        src={item.linkpicture}
                                        alt={item.title || 'banner ' + index}
                                        style={{ width: '100%', display: 'block', borderRadius: '0.5rem' }}
                                    />
                                </a>
                            )}
                        </div>
                    ))}
                </Slider>
            </div>
            </div>
        );
    }
}

export default SubBanner;
